import RequestSidebar from "@components/RequestSidebar/RequestSidebar";
import { SegmentEventName } from "@tsTypes/__generated__/enums";
import { track } from "@utils/appUtils";
import { t } from "@utils/i18n";
import { RefObject, useMemo } from "react";

interface Props {
  backgroundRef: RefObject<HTMLElement>;
  lookingForRef: RefObject<HTMLElement>;
  benefitsRef: RefObject<HTMLElement>;
  whoWeAreRef: RefObject<HTMLElement>;
  qaRef: RefObject<HTMLElement>;
  blockedKeys?: Section[];
  onSignupClick?: () => void;
  topOffset?: number;
}

enum Section {
  BACKGROUND = "background",
  LOOKING_FOR = "looking-for",
  BENEFITS = "benefits",
  WHO_WE_ARE = "who-we-are",
  QA = "qa",
}

export default function Sidebar({
  backgroundRef,
  lookingForRef,
  benefitsRef,
  whoWeAreRef,
  qaRef,
  blockedKeys = [],
  onSignupClick,
  topOffset = 20,
}: Props) {
  const items = useMemo(
    () => [
      {
        key: Section.BACKGROUND,
        ref: backgroundRef,
        title: t("pages.request_for_startups_page.headings.background"),
      },
      {
        key: Section.LOOKING_FOR,
        ref: lookingForRef,
        title: t("pages.request_for_startups_page.headings.looking_for"),
      },
      {
        key: Section.BENEFITS,
        ref: benefitsRef,
        title: t("pages.request_for_startups_page.headings.offer"),
      },
      {
        key: Section.WHO_WE_ARE,
        ref: whoWeAreRef,
        title: t("pages.request_for_startups_page.headings.who_we_are"),
      },
      { key: Section.QA, ref: qaRef, title: t("pages.request_for_startups_page.headings.q_a") },
    ],
    [backgroundRef, lookingForRef, benefitsRef, whoWeAreRef, qaRef]
  );

  return (
    <RequestSidebar
      items={items}
      blockedKeys={blockedKeys}
      onSignupClick={onSignupClick}
      topOffset={topOffset}
      onItemClick={(key) => {
        track(SegmentEventName.CLICK, {
          ui_component: "Request for Startup Page - Sidebar",
          key,
        });
      }}
    />
  );
}
